import { CARRIER_OPTIONS } from "./components/ShippingEditor";

/** Nome leggibile del corriere («POSTE_DELIVERY» → «Poste Delivery»): il
 *  codice grezzo resta nei dati, a video va il nome. */
export function nomeCorriere(codice: string | undefined): string {
  const c = (codice ?? "").trim().toUpperCase();
  if (!c) return "—";
  return CARRIER_OPTIONS.find((o) => o.value === c || o.label.toUpperCase() === c)?.label ?? c;
}
